import styled from "styled-components";
import colors from "assets/styles/colors";

export const SelectContainer = styled.div`
    display: flex;
    align-items: center;

    padding: 8px 15px;

    min-width: fit-content;

    background-color: ${(props) => props.theme.filterButtonBackground};
    color: ${(props) => props.theme.filterButtonForeground};

    border-radius: 5px;

    &.enabled {
        :hover {
            background-color: ${(props) =>
                props.theme.filterButtonBackgroundHover};
        }
        cursor: pointer;
    }

    &.error {
        border: 2px solid lightcoral;
        padding: 6px 13px;
    }

    margin-bottom: 10px;
    margin-right: 10px;
    user-select: none;

    max-height: 40px;
    min-height: 40px;

    p {
        letter-spacing: 1px;
    }

    .filterLabel {
        &.showAll {
            flex-grow: 1;
        }

        &.showSelect {
            flex-grow: none;
            color: lightgray;
        }
    }

    .filterLabelFullWidth {
        flex-grow: 1;
    }

    .value {
        font-weight: bolder;
        margin-left: 15px;
        display: flex;
    }

    .selected {
        display: flex;
        flex-grow: 1;
        margin-right: 10px;
    }

    .clearIcon {
        color: #777777;
        margin-right: 5px;
        &:hover {
            color: #555555;
        }
    }

    .clearFilter {
        margin-left: 10px;
        display: flex;
    }

    + .errorText {
        color: red;
        font-size: 14px;
        margin-top: 5px;
        margin-bottom: 10px;
    }
`;

export const PopUpContainer = styled.div<{ $fitContent?: boolean }>`
    display: flex;
    flex-direction: column;

    background-color: ${(props) => props.theme.dropDownMenuBackground};
    color: ${(props) => props.theme.dropDownMenuText};

    box-shadow: 5px 5px 15px 5px rgba(0, 0, 0, 0.28);

    margin-top: 5px;
    /* max-width: 250px; */

    user-select: none;

    .searchBox {
        border-bottom: 1px solid
            ${(props) => props.theme.dropDownSearchBoxBorder};
        background-color: ${(props) => props.theme.dropDownMenuBackground};
        color: ${(props) => props.theme.dropDownMenuText};

        align-items: center;
        display: flex;
        // with $fitContent=true search box width will adapt to the option width, where the actual content is located
        max-width: ${(props) => (props.$fitContent ? undefined : "250px")};
        min-width: 250px;
        margin: 0 !important;

        input {
            border: none;
            height: 40px;
            font-size: 18px;
            background-color: ${(props) => props.theme.dropDownMenuBackground};
            color: ${(props) => props.theme.dropDownMenuText};
            padding-left: 15px;
            outline: none;
            display: flex;
            flex-grow: 1;
        }

        svg {
            margin: 0 10px;
            color: ${(props) => props.theme.dropDownSearchBoxIcon};
        }

        :hover {
            background-color: ${(props) => props.theme.dropDownBackgroundHover};

            input {
                background-color: ${(props) =>
                    props.theme.dropDownBackgroundHover};
            }
        }
    }

    .loading {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-grow: 1;
        min-height: 100px;
        min-width: 250px;
    }

    .options {
        flex-direction: column;
        display: flex;
        max-height: 400px;
        overflow-y: scroll;

        button {
            border: none;
            background: none;
            cursor: pointer;
            width: 100%;
            text-align: left;
            padding: inherit;
            margin: 0;
            font-size: inherit;
        }

        .option {
            min-width: 150px;
            max-width: ${(props) =>
                props.$fitContent ? "fit-content" : "250px"};
            cursor: pointer;

            :hover,
            &.selected {
                background-color: ${(props) =>
                    props.theme.dropDownBackgroundHover};
            }
            p {
                margin: 10px 15px;
            }
            .info {
                color: ${colors.accentBlue};
            }
            .warning {
                color: ${colors.accentOrange};
            }
            .critical {
                color: ${colors.accentRed};
            }
        }

        .noResults {
            min-width: 150px;
            width: 100%;
            p {
                margin: 10px 15px;
                width: 100%;
                text-align: center;
                color: ${(props) => props.theme.dropDownMenuText};
            }
        }
    }

    .date {
        div {
            display: block;
        }
        .react-datepicker__day-name,
        .react-datepicker__day {
            display: inline-block;
        }
    }
`;
